import React, { useEffect, useRef } from "react";
import "../styles/Contact.css";
import { FaPhone, FaEnvelope, FaWhatsapp, FaMapMarkerAlt } from "react-icons/fa";
import { useLanguage } from "../contexts/LanguageContext";

const Contact: React.FC = () => {
  const { t } = useLanguage();
  const mapRefs = useRef<HTMLDivElement[]>([]);
  
  useEffect(() => {
    // Scroll animasyonu için gözlemci oluşturma
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    // Tüm harita containerlarını gözlemle
    mapRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    // DÜZELTME: cleanup için referansı kopyala
    const refs = mapRefs.current;
    return () => {
      refs.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  // Harita referanslarını temizleme ve yeniden oluşturma
  const addToRefs = (el: HTMLDivElement | null) => {
    if (el && !mapRefs.current.includes(el)) {
      mapRefs.current.push(el);
    }
  };

  return (
    <div className="contact-container">
      <div className="breadcrumb">{t('contact.breadcrumb')}</div>
      <h1 className="contact-title">{t('contact.title')}</h1>

      <div className="contact-columns">
        {/* HAS GÜMÜŞ DEĞERLİ MADENLER */}
        <div className="contact-column">
          <div className="contact-block">
            <div className="contact-item">
              <div className="contact-icon-wrapper">
                <FaMapMarkerAlt className="contact-icon" />
              </div>
              <div className="contact-text">
                <h3>{t('contact.companyName')}</h3>
                <p className="contact-address" dangerouslySetInnerHTML={{ __html: t('contact.address') }}></p>
                <div className="contact-phone-numbers">
                  <span className="phone-number whatsapp-number">
                    <FaWhatsapp /> +90 536 456 43 06
                  </span>
                  <span className="phone-number regular-number">
                    <FaPhone /> 0212 514 88 53 - 0212 514 88 56
                  </span>
                </div>
                <div className="address-image-container">
                  <img src={require("../assets/images/merkez.png")} alt="Has Gümüş Merkez" className="address-image" />
                </div>
              </div>
            </div>
            <div className="map-wrapper" ref={addToRefs}>
              <h3>{t('contact.companyName')}</h3>
              <a 
                href="https://maps.app.goo.gl/2BxbPm5XctTaSgEF7" 
                target="_blank" 
                rel="noopener noreferrer"
                className="directions-button"
              >
                {t('contact.directions')}
              </a>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d752.6672859997923!2d28.9693825!3d41.0106143!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab99406b73637%3A0xe28389473b32e09d!2zSGFzIEfDvG3DvMWfIERlxJ9lcmxpIE1hZGVubGVyIEEuxZ4u!5e0!3m2!1str!2str!4v1767609607606!5m2!1str!2str"
                width="100%"
                height="450"
                style={{ border: 0, borderRadius: "15px" }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Has Gümüş Değerli Madenler Harita"
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      <div className="icon-bar">
        <a href="mailto:info@hghasgumus.com" className="icon mail" aria-label={t('contact.emailLabel')}>
          <FaEnvelope />
        </a>
        <a href="tel:+902125148853" className="icon phone" aria-label={t('contact.phoneLabel')}>
          <FaPhone />
        </a>
        <a href="https://wa.me/905364564306" className="icon whatsapp" aria-label={t('contact.whatsappLabel')}>
          <FaWhatsapp />
        </a>
      </div>
    </div>
  );
};

export default Contact;